
import Button from '../../../components/base/Button';

export default function FinalCTASection() {
  return (
    <section className="relative py-24 bg-gradient-to-r from-gray-900 via-black to-gray-900 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e896d3c795585ae0140402f76cf4f7d4.jpg')`
        }}
      ></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Ready to Deploy Your First{' '}
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              A.I. Agent?
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto">
            Join hundreds of businesses already using A.I. to automate their growth. Get started today with a free consultation.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button size="lg" href="/contact" className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600">
              <i className="ri-rocket-line mr-2"></i>
              Start Your A.I. Transformation
            </Button>
            <Button variant="outline" size="lg" href="/case-studies" className="border-gray-400 text-gray-300 hover:border-white hover:text-white">
              <i className="ri-play-circle-line mr-2"></i>
              Watch Demo
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <div className="text-3xl font-bold text-blue-400 mb-2">24/7</div>
              <div className="text-gray-300">Always Working</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <div className="text-3xl font-bold text-purple-400 mb-2">3x</div>
              <div className="text-gray-300">More Leads</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <div className="text-3xl font-bold text-blue-400 mb-2">ROI</div>
              <div className="text-gray-300">Guaranteed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
